import teams from './teams.json';

export const allTeams = teams;

export const findTeamById = (id) => teams.find((team) => team.id === id);

export const findTeamByLabel = (label) => {
  if (!label) return undefined;
  const q = label.trim().toLowerCase();
  return teams.find((team) => team.label.toLowerCase() === q);
};

export const customTeam = (label) => ({
  id: '',
  league: '',
  label,
  fullName: label,
  abbreviation: '',
  logo: '',
  custom: true,
});

export const searchTeams = (query, limit = 12) => {
  const q = query.trim().toLowerCase();
  if (!q) {
    return [];
  }

  const scored = [];
  teams.forEach((team) => {
    const label = team.label.toLowerCase();
    const abbr = (team.abbreviation || '').toLowerCase();
    const fullName = team.fullName.toLowerCase();
    let score = 0;

    if (abbr === q) score = 100;
    else if (label === q) score = 90;
    else if (fullName === q) score = 85;
    else if (label.startsWith(q)) score = 80;
    else if (abbr.startsWith(q)) score = 70;
    else if (team.search.includes(q)) score = 50;
    else return;

    if (team.league === 'NFL') score += 1;
    scored.push({ team, score });
  });

  return scored
    .sort((a, b) => b.score - a.score || a.team.label.localeCompare(b.team.label))
    .slice(0, limit)
    .map((entry) => entry.team);
};
